import { agencyInfo } from '../../../mocks/dashboard';

interface KPICardProps {
  label: string;
  value: number;
  sub: string;
  trend: number;
  positive: boolean;
  icon: string;
}

const brand = agencyInfo.brandColor;

const colorMap: Record<string, { bg: string; icon: string }> = {
  teal: { bg: '#F0FDFA', icon: '#0D9488' },
  emerald: { bg: '#ECFDF5', icon: '#059669' },
  green: { bg: '#F0FDF4', icon: '#16A34A' },
  amber: { bg: '#FFFBEB', icon: '#D97706' },
};

const sparkData = [40, 55, 45, 60, 52, 68, 72, 65, 78, 82];

function Spark({ color }: { color: string }) {
  const max = Math.max(...sparkData);
  const points = sparkData
    .map((v, i) => `${(i / (sparkData.length - 1)) * 80},${28 - (v / max) * 24}`)
    .join(' ');

  return (
    <svg width="80" height="28" viewBox="0 0 80 28" fill="none">
      <polyline points={points} stroke={color} strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" fill="none" />
    </svg>
  );
}

export default function KPICard({ label, value, sub, trend, positive, icon }: KPICardProps) {
  const colors = colorMap.teal;

  const formattedValue =
    label.toLowerCase().includes('revenue') || label.toLowerCase().includes('payment')
      ? `AED ${value.toLocaleString()}`
      : value.toLocaleString();

  return (
    <div className="bg-white rounded-2xl border border-gray-100 p-5 flex flex-col gap-3 hover:border-gray-200 transition-colors">
      <div className="flex items-start justify-between">
        <div className="w-10 h-10 flex items-center justify-center rounded-xl" style={{ backgroundColor: colors.bg }}>
          <i className={`${icon} text-xl`} style={{ color: brand }} />
        </div>
        <span
          className={`flex items-center gap-1 text-xs font-semibold px-2 py-1 rounded-full ${
            positive ? 'bg-green-50 text-green-600' : 'bg-red-50 text-red-500'
          }`}
        >
          <i className={`${positive ? 'ri-arrow-up-line' : 'ri-arrow-down-line'} text-xs`} />
          {Math.abs(trend)}%
        </span>
      </div>

      <div>
        <p className="text-2xl font-bold text-gray-800 leading-tight">{formattedValue}</p>
        <p className="text-xs text-gray-400 mt-0.5 uppercase tracking-wide font-medium">{label}</p>
      </div>

      <div className="flex items-end justify-between">
        <p className="text-xs text-gray-400">{sub}</p>
        <Spark color={brand} />
      </div>
    </div>
  );
}
